import { render, staticRenderFns } from "./json.vue?vue&type=template&id=4b644fc4&scoped=true&"
import script from "./json.vue?vue&type=script&lang=js&"
export * from "./json.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b644fc4",
  null
  
)

export default component.exports